import { defineMessages } from "react-intl";

const messages = defineMessages({
    startEdit: {
        id: "task.embed.startEdit",
    },
    stopEdit: {
        id: "task.embed.stopEdit",
    },
    loading: {
        id: "general.loading",
    },
    start: {
        id: "task.embed.startTime",
    },
    end: {
        id: "task.embed.endTime",
    },
    provider: {
        id: "task.embed.provider",
    },
});

export default messages;
